export default __webpack_public_path__ + "static/media/luggage 1.aa7de2f3.svg";